import { forwardRef, useId, type TextareaHTMLAttributes } from 'react';

import { cn } from './cn';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  hint?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, error, hint, className, id, rows = 4, ...rest }, ref) => {
    const autoId = useId();
    const textId = id ?? autoId;
    return (
      <div className="flex flex-col gap-1">
        {label && (
          <label htmlFor={textId} className="text-sm font-medium text-navy-900">
            {label}
          </label>
        )}
        <textarea
          ref={ref}
          id={textId}
          rows={rows}
          aria-invalid={!!error}
          className={cn(
            'rounded-lg border border-cream-300 bg-cream-100 px-3 py-2 text-navy-900 placeholder:text-ink-muted',
            'focus:border-rose-500 focus:outline-none focus:ring-2 focus:ring-rose-500/30',
            error && 'border-lacquer focus:border-lacquer focus:ring-lacquer/30',
            className,
          )}
          {...rest}
        />
        {error ? (
          <p className="text-xs text-lacquer">{error}</p>
        ) : hint ? (
          <p className="text-xs text-ink-muted">{hint}</p>
        ) : null}
      </div>
    );
  },
);
Textarea.displayName = 'Textarea';
